<template>
  <v-card flat>
    <div
      class="secondarytext--text text-h6 pa-4 cursor-pointer"
      @click="$emit('cancel')"
    >
      <v-icon class="mr-2" color="secondarytext">keyboard_arrow_left</v-icon>
      Edit Sub-Category
    </div>
    <v-divider></v-divider>
    <v-card-text class="pb-0 pt-4">
      <v-form ref="form" v-model="valid">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="subCategory.name"
              outlined
              label="Name"
              :rules="[$rules.required]"
              maxlength="100"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              outlined
              v-model="subCategory.description"
              label="Description"
              maxlength="500"
              :rules="[$rules.required]"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="save" :loading="saving">
        Update
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EditPulseSubCategoryForm",
  props: { subCategory: { type: Object } },
  data: () => ({
    saving: false,
    valid: false
  }),
  computed: {
    ...mapGetters({})
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("pulse/saveSubCategory", this.subCategory)
          .then(id => {
            this.$emit("save", id);
            this.$root.$snackbarSuccess("Sub-Category saved");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your sub-category."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
